import { useTranslation } from "react-i18next";
import './SurveyModal.css'

import arrowdone from "../../assets/survey/arrowdone.svg";

function SurveyThankYouScreen({ closeModal }) {

    const { t } = useTranslation()
    let lng = JSON.parse(localStorage.getItem("language"))?.lang;
    return (<>

        <img style={{ width: '200px', height: '200px', color: 'green' }} src={arrowdone} alt="arrow_next" />
        <div style={{ font: "Poppins" }}>
            {t("Thank you for completing the survey")}
        </div>
        <div className="survey_common_style_center survey_full_width">
            <div className="survey_modal_bottom">
                <button onClick={() => closeModal()} className="survey_moveOn_btn">
                    <div style={lng === "arab" ? { direction: "rtl" } : null}>{t("Close")}</div>
                </button>

            </div>
        </div>
    </>)

}

export default SurveyThankYouScreen